/**
 * API endpoints
 */
export const INDEXER_URL = 'https://xswap.squids.live/xswap:main/api/graphql'
